import React from "react";
import camera from "../../images/photo_camera.svg";
import styled from "styled-components";

const InputImage = ({name, image, onChange, setOpenDeleteModal}) => {


    return (
        <div>
            <ImgContainer>
                <img className={"strategy-img"} src={image} alt={name}/>
                <Div>
                    <button type={"button"} className={name.includes("strat") ? "" : "display-none"} onClick={() => setOpenDeleteModal(true)}>
                        <svg width="15" height="15" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.8037 0.629228L10.8041 0.628866C10.9638 0.46918 11.2205 0.46918 11.3802 0.628866C11.5308 0.779452 11.5308 1.04535 11.3802 1.19594L6.92972 5.64645L6.57617 6L6.92972 6.35355L11.3802 10.8041C11.5399 10.9638 11.5399 11.2205 11.3802 11.3802C11.2205 11.5399 10.9638 11.5399 10.8041 11.3802L6.35355 6.92972L6 6.57617L5.64645 6.92972L1.19594 11.3802C1.03625 11.5399 0.779452 11.5399 0.619765 11.3802C0.460078 11.2205 0.460078 10.9638 0.619765 10.8041L5.07028 6.35355L5.42383 6L5.07028 5.64645L0.619765 1.19594C0.460078 1.03625 0.460078 0.779452 0.619765 0.619765C0.779452 0.460078 1.03625 0.460078 1.19594 0.619765L5.64645 5.07028L5.99964 5.42347L6.35319 5.07064L10.8037 0.629228Z"
                                fill="white" stroke="rgba(33, 37, 41, 1)"/>
                        </svg>
                    </button>
                    <Label>
                        <Input
                            className={"file"}
                            type="file"
                            name={"image"}
                            accept={"image/*"}
                            multiple={false}
                            onChange={onChange}
                        />
                        <img src={camera} alt={"changer"}/>
                    </Label>
                </Div>
            </ImgContainer>
        </div>
    )
}

const ImgContainer = styled.div`
  height: fit-content;
  display: flex;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: rgba(166, 172, 181, 0.6);
    border-radius: 50%;
    border: none;
    width: 2rem;
    height: 2rem;
    cursor: pointer;


    &:hover {
      background: rgba(166, 172, 181, 0.3);
    }
  }

  .strategy-img {
    width: 6em;
    height: 6em;
    border-radius: 50%;
    object-fit: cover;
  }

`

const Div = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  position: relative;
  left: -20px;
`
const Label = styled.label`

  background: rgba(166, 172, 181, 0.6);
  border-radius: 50%;
  position: relative;
  width: 2em;
  height: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: rgba(166, 172, 181, 0.3);
  }
`

const Input = styled.input`
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
  cursor: pointer;

`
export default InputImage;